<template>
  <div>
    <tk-text-box
      :theme="theme"
      :placeholder="placeholder"
      :value="condition.departurePlaceName"
      :size="size"
      :icon="icon"
      :put-icon-outside="putIconOutside"
      :icon-color="iconColor"
      :icon-separator="iconSeparator"
      cursor="pointer"
      :disabled="condition.departurePlaces.items.length === 0 || disabled"
      readonly
      @click="isModalOpened = true"
    />
    <tk-general-purpose-modal
      v-if="isModalOpened"
      no-show-header
      class="departurePlacePicker_modal"
      @close="isModalOpened = false"
    >
      <div class="departurePlacePicker_modalHeader">
        出発地を選択
        <span
          class="departurePlacePicker_modalHeaderCrossMarkArea"
          @click="isModalOpened = false"
        >
          <tk-cross-mark />
        </span>
      </div>
      <tk-selectable-list
        :items="condition.departurePlaces.withNamesModifiedForDisplay.items"
        @selected="select($event)"
      />
    </tk-general-purpose-modal>
  </div>
</template>

<script>
import { TkCrossMark, TkGeneralPurposeModal, TkSelectableList, TkTextBox } from '@ota-frontend/ui'
import { SearchCondition } from '@/models'

export default {
  name: 'DeparturePlacePicker',

  components: { TkCrossMark, TkGeneralPurposeModal, TkSelectableList, TkTextBox },

  model: {
    prop: 'condition',  // withDeparturePlaces で departurePlaces を付与したものが必要
    event: 'selected',
  },

  props: {
    condition: {
      type: SearchCondition,
      required: true,
    },
    theme: {
      type: String,
      default: 'default',
    },
    size: {
      type: String,
      default: 'normal',  // normal, large, x-large, xx-large, xxx-large
    },
    placeholder: {
      type: String,
      default: '出発地を選択',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: 'place',
    },
    putIconOutside: {
      type: Boolean,
      default: false,
    },
    iconColor: {
      type: String,
      default: '',
    },
    iconSeparator: {
      type: String,
      default: '',
    },
  },

  data: () => ({
      isModalOpened: false,
  }),

  methods: {
    select(id) {
      this.isModalOpened = false
      this.$emit('selected', this.condition.update({
        [SearchCondition.PARAMS.DEPARTURE_PLACE]: Number(id),
      }))
    },
  },
}
</script>

<style lang="scss">
// モーダルコンポーネントが親からスタイルを指定する仕様のため、やむなく scoped を外している
.departurePlacePicker_modal {
  .modal-content {
    background: none;
  }

  &.modal-sp-fullscreen {
    background: none;
  }
}
</style>

<style scoped lang="scss">
.departurePlacePicker_modalHeader {
  position: relative;
  width: 100%;
  margin: auto;
  padding: 15px 0;
  background: #f9423a url(https://www.tabikobo.com/images/new2016/icon_select_area_w.png) no-repeat scroll 2% center / 20px auto;
  color: #fff;
  font-size: 14px;
  font-family: "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro", "メイリオ", Meiryo, "ＭＳ Ｐゴシック", "MS PGothic", Osaka, sans-serif;
  text-align: center;
}

.departurePlacePicker_modalHeaderCrossMarkArea {
  display: table-cell;
  position: absolute;
  top: 20px;
  right: 0;
  float: none;
  width: 40px;
  height: 100%;
  border-radius: 0;
  background: none;
  cursor: pointer;
}
</style>
